import { Component } from '@angular/core';
import { assets } from '../../../core/constants/assets.const';

@Component({
  selector: 'mindbase-auth-right',
  standalone: true,
  imports: [],
  templateUrl: './auth-right.component.html',
  styleUrl: './auth-right.component.scss'
})
export class AuthRightComponent {
  assetsConst = assets;
}
